import { PatientGuarantorWritable, PatientInsurance } from "pwapi";

import { UserLocation } from "custom-models";

import {
  ADMIN_CREATE_INSURANCE_REQUEST,
  ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST,
  ADMIN_DELETE_INSURANCE_REQUEST,
  ADMIN_UPDATE_INSURANCE_REQUEST,
  ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST,
  ADMIN_UPDATE_PATIENT_LOCATION_REQUEST,
  ADMIN_UPDATE_PATIENT_REQUEST,
} from "../adminConstants";

export const savePatient = (payload: any = {}) => {
  return {
    type: ADMIN_UPDATE_PATIENT_REQUEST,
    payload,
  };
};

export const updateInsurance = (payload: {
  insurance: PatientInsurance;
  caseId: number;
  patientId: number;
  primaryInsurance?: PatientInsurance;
  onClose?: Function;
}) => {
  return {
    type: ADMIN_UPDATE_INSURANCE_REQUEST,
    payload,
  };
};

export const createInsurance = (payload: {
  insurance: PatientInsurance;
  patientId: number;
  primaryInsurance?: PatientInsurance;
  onClose?: Function;
}) => {
  return {
    type: ADMIN_CREATE_INSURANCE_REQUEST,
    payload,
  };
};

export const updatePatientAddress = (
  payload: UserLocation,
  onClose?: Function
) => {
  return {
    type: ADMIN_UPDATE_PATIENT_LOCATION_REQUEST,
    payload: {
      location: payload,
      onClose,
    },
  };
};

export const deleteInsurance = (payload: {
  id: number;
  onClose?: Function;
}) => {
  return {
    type: ADMIN_DELETE_INSURANCE_REQUEST,
    payload,
  };
};

export const createPatientGuarantor = (
  payload: PatientGuarantorWritable & { onClose?: Function }
) => {
  return {
    type: ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST,
    payload: payload,
  };
};

export const updatePatientGuarantor = (
  payload: PatientGuarantorWritable & {
    onClose?: Function;
    patient_id?: number;
  }
) => {
  return {
    type: ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST,
    payload: payload,
  };
};
